import { useOnboardingAnalytics } from "analytics/onboarding";
import {
  GroupType,
  OnboardingDetailedStep,
  SignalsGroupsType,
} from "@shared/features/onboarding/types.ts";
import { GroupData, MarketplaceSubGroup } from "@shared/types";
import React, { useContext } from "react";
import { OnboardingContext } from "@shared/features/onboarding/Onboarding.context.ts";
import { GroupsPageContext } from "@shared/features/groups/GroupsPage.context.ts";
import { getGroupExtraDetailsRoute } from "utils/routes.tsx";
import {
  SECTION_TYPE_TO_TRADING_CATEGORY,
  TRADING_CATEGORY_TO_CATEGORY_CONST,
} from "features/onboarding/common/constants.ts";
import MyGroupCard from "features/onboarding/methodSettings/signalsGroup/groupCards/MyGroupCard.tsx";
import GroupCard from "features/newMarketplace/GroupCard.tsx";
import { useHistory } from "react-router-dom";

interface GroupCardComponentProps {
  data: GroupType;
  extraData?: (group: MarketplaceSubGroup) => void;
  index: number;
}

const GroupCardComponent = ({
  data,
  extraData,
  index,
}: GroupCardComponentProps) => {
  const { changeStep } = useContext(OnboardingContext) || {};
  const { isGroupsPage } = useContext(GroupsPageContext)!;
  const track = useOnboardingAnalytics();
  const history = useHistory();

  const followGroup = () => {
    if (isGroupsPage && data.group_type === SignalsGroupsType.FREE_TRIAL) {
      history.push(
        getGroupExtraDetailsRoute(location.pathname, data.id.toString())
      );
    } else if (changeStep) {
      const tradingMethodCategory =
        TRADING_CATEGORY_TO_CATEGORY_CONST[
          SECTION_TYPE_TO_TRADING_CATEGORY[data.group_type]
        ]?.toString();
      track("Channel Selected", {
        group_id: data.id,
        rank: index + 1,
        category: data.group_type,
      });
      changeStep?.(OnboardingDetailedStep.SIGNALS_GROUP_OVERVIEW, {
        groupID: data.id.toString(),
        category: tradingMethodCategory,
        groupRank: index.toString(),
      });
    }
  };

  if (
    data.group_type === SignalsGroupsType.MY_GROUPS ||
    data.group_type === SignalsGroupsType.PERSONAL
  ) {
    return <MyGroupCard group={data as GroupData} onCardClick={followGroup} />;
  }

  return (
    <GroupCard
      group={data as MarketplaceSubGroup}
      index={index}
      onCardClick={followGroup}
      openScoreModal={extraData}
      isOnboarding={true}
    />
  );
};

export default React.memo(GroupCardComponent);
